import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ensureUserSession, readUserSession } from './userSession';

const LOGIN_REQUIRED_MESSAGE = '로그인 후 이용할 수 있습니다. 로그인해주세요.';

// URL로 직접 들어오거나 토큰이 만료·로그아웃되면 로그인 페이지로 돌려보낸다.
// 만료된 토큰은 refresh 쿠키로 재발급을 먼저 시도한다.
export default function RequireLogin({ children }) {
    const location = useLocation();
    const [status, setStatus] = useState('checking');
    const alerted = useRef(false);

    useEffect(() => {
        let active = true;
        ensureUserSession().then(session => { if (active) setStatus(session ? 'allowed' : 'denied'); });
        const updateAuth = () => { if (!readUserSession()) setStatus('denied'); };
        window.addEventListener('garam-auth-change', updateAuth);
        return () => {
            active = false;
            window.removeEventListener('garam-auth-change', updateAuth);
        };
    }, []);

    useEffect(() => {
        // StrictMode의 이중 실행에서도 안내창은 한 번만 띄운다.
        if (status !== 'denied' || alerted.current) return;
        alerted.current = true;
        window.alert(LOGIN_REQUIRED_MESSAGE);
    }, [status]);

    if (status === 'checking') return <p role="status" style={{ padding: '48px 16px', textAlign: 'center' }}>로그인 정보를 확인하고 있습니다.</p>;
    if (status === 'denied') return <Navigate to="/login" replace state={{ from: location }} />;
    return children;
}

RequireLogin.propTypes = {
    children: PropTypes.node.isRequired,
};
